"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRedux = require("react-redux");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _MerchCardTermSelectorContainer = _interopRequireDefault(require("./MerchCardTermSelectorContainer"));

var _Terms = require("self-service-api/constants/Terms");

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseTypes = require("self-service-api/constants/PurchaseTypes");

var _colors = require("HubStyleTokens/colors");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 16px;\n  font-weight: 500;\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-decoration: line-through;\n  font-size: 16px;\n  font-weight: 400;\n  color: ", ";\n  margin-right: 4px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "Mon279PerUserPriceHeader__CrossedOutPrice",
  componentId: "jdw7wj-0"
})(_templateObject(), _colors.SLINKY);
var StyledPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "Mon279PerUserPriceHeader__StyledPrice",
  componentId: "jdw7wj-1"
})(_templateObject2());

var PriceLabel = _styledComponents.default.span.withConfig({
  displayName: "Mon279PerUserPriceHeader__PriceLabel",
  componentId: "jdw7wj-2"
})(_templateObject3(), function (props) {
  return props.showDiscountedPricing && "color: " + _colors.OZ + ";";
});

var Mon279PriceDisplay = function Mon279PriceDisplay(_ref) {
  var originalPrice = _ref.originalPrice,
      price = _ref.price,
      currencyCode = _ref.currencyCode,
      isSeatBased = _ref.isSeatBased;
  var showDiscountedPricing = originalPrice && originalPrice !== price;
  return _react.default.createElement("div", {
    style: {
      padding: '10px 0 2px 0'
    }
  }, showDiscountedPricing && _react.default.createElement(CrossedOutPrice, {
    currencyCode: currencyCode,
    price: originalPrice
  }), _react.default.createElement(PriceLabel, {
    showDiscountedPricing: showDiscountedPricing
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: isSeatBased ? 'mon279.pricePerPaidUserPerMonth_jsx' : 'mon279.pricePerMonth_jsx',
    elements: {
      Price: StyledPrice
    },
    options: {
      price: price,
      currencyCode: currencyCode
    }
  })));
};

var Mon279PerUserPriceHeader = function Mon279PerUserPriceHeader(_ref2) {
  var hasPricingAndPurchasingSucceeded = _ref2.hasPricingAndPurchasingSucceeded,
      hub = _ref2.hub,
      merchandiseId = _ref2.merchandiseId,
      headerConfig = _ref2.headerConfig,
      activeTerm = _ref2.activeTerm,
      setActiveTerm = _ref2.setActiveTerm,
      calculatePrice = _ref2.calculatePrice,
      currencyCode = _ref2.currencyCode,
      getAdditionalContactsMonthlyCost = _ref2.getAdditionalContactsMonthlyCost,
      merchandiseMap = _ref2.merchandiseMap;
  if (!hasPricingAndPurchasingSucceeded) return null;
  var title = headerConfig.title,
      mon279Includes = headerConfig.mon279Includes,
      icon = headerConfig.icon;
  var pricingInfo = calculatePrice({
    merchandiseId: merchandiseId,
    term: activeTerm
  });
  var _pricingInfo$monthly = pricingInfo.monthly,
      monthlyFullPrice = _pricingInfo$monthly.fullPrice,
      monthlyCalculatedPrice = _pricingInfo$monthly.calculatedPrice;
  var merchPurchaseType = _HubMap.default[hub].merchPurchaseType;
  var isSeatBased = merchPurchaseType === _PurchaseTypes.SEAT_BASED;

  if (isSeatBased) {
    var numUsers = merchandiseMap[merchandiseId].includedAdditionalUnits;
    monthlyFullPrice /= numUsers;
    monthlyCalculatedPrice /= numUsers;
  }

  return _react.default.createElement("div", null, _react.default.createElement(_UIFlex.default, {
    className: "m-right-1",
    align: "center"
  }, _react.default.createElement(_UIImage.default, {
    className: "display-inline",
    src: icon
  }), _react.default.createElement("h2", {
    className: "m-bottom-0 m-left-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: title
  }))), _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: ['0.75em', 30, 10],
    widths: [60, 60, 60]
  }, _react.default.createElement(Mon279PriceDisplay, {
    currencyCode: currencyCode,
    originalPrice: monthlyFullPrice,
    price: monthlyCalculatedPrice,
    isSeatBased: isSeatBased
  })), mon279Includes && _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: mon279Includes
  }), _react.default.createElement(_UIHelpIcon.default, {
    style: {
      marginLeft: '2px'
    },
    size: "small",
    title: merchPurchaseType === _PurchaseTypes.CONTACT_BASED ? _react.default.createElement(_FormattedJSXMessage.default, {
      message: "mon279.contactsSubtext.additionalContacts_jsx",
      elements: {
        Price: _PriceDisplay.default
      },
      options: {
        currencyCode: currencyCode,
        price: getAdditionalContactsMonthlyCost(merchandiseId, activeTerm)
      }
    }) : _react.default.createElement(_FormattedMessage.default, {
      message: "mon279.usersSubtext.freeUsers"
    })
  })), _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement("p", null, activeTerm === _Terms.MONTHLY ? _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.billingCaptions.monthly"
  }) : _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.billingCaptions.annual"
  }))), _react.default.createElement(_MerchCardTermSelectorContainer.default, {
    activeTerm: activeTerm,
    merchandiseId: merchandiseId,
    onChange: function onChange(term) {
      return setActiveTerm(term);
    }
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    calculatePrice: (0, _PricingSelectors.getCalculatePriceAndItemConfigSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getAdditionalContactsMonthlyCost: (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state),
    merchandiseMap: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Mon279PerUserPriceHeader);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/Mon279PerUserPriceHeader.js
// module id = 838
// module chunks = 5 6